import type { ImportAdapter } from '../types';
import { createZipImportAdapter } from './zip-import.adapter';

// =============================================================================
// CAMPAIGN AUTOMATION IMPORT ADAPTER
// =============================================================================

/**
 * Campaign Automation Import Adapter
 *
 * Handles import of automated campaign scenarios from ZIP files.
 * Uses the shared ZIP import adapter factory for common functionality.
 *
 * Flow:
 * 1. User uploads a ZIP file containing automation scenarios
 * 2. System calls describe-file API to list available scenarios
 * 3. User selects which scenarios to import
 * 4. System imports selected scenarios
 */
const baseAdapter = createZipImportAdapter({
  type: 'campaign_automation',
  emptyFileErrorKey: 'import.itemSelector.noAutomationFound',
  alternativeType: 'automation',
});

export const campaignAutomationAdapter: ImportAdapter = {
  ...baseAdapter,
  processingMode: 'immediate',
};

export default campaignAutomationAdapter;
